// type SortOrder = 'asc' | 'desc';

// export const sortArrayObjectByKey = <T>(
//   array: T[],
//   key: keyof T,
//   order: SortOrder = 'asc'
// ): T[] => {
//   return [...array].sort((a, b) => {
//     const aVal = a[key];
//     const bVal = b[key];

//     if (aVal == null || bVal == null) return 0;

//     if (typeof aVal === 'string' && typeof bVal === 'string') {
//       return order === 'asc'
//         ? aVal.localeCompare(bVal)
//         : bVal.localeCompare(aVal);
//     }

//     if (typeof aVal === 'number' && typeof bVal === 'number') {
//       return order === 'asc' ? aVal - bVal : bVal - aVal;
//     }

//     return 0;
//   });
// };


// utils/ArrayHelper.ts

type SortOrder = 'asc' | 'desc';

export class ArrayHelper<T> {
  constructor(private array: T[]) {}

  sortByKey<K extends keyof T>(key: K, order: SortOrder = 'asc'): ArrayHelper<T> {
    const sorted = [...this.array].sort((a, b) => {
      const aVal = a[key];
      const bVal = b[key];

      if (aVal == null || bVal == null) return 0;

      if (typeof aVal === 'string' && typeof bVal === 'string') {
        return order === 'asc'
          ? aVal.localeCompare(bVal, undefined, { numeric: true })
          : bVal.localeCompare(aVal, undefined, { numeric: true });
      }

      if (typeof aVal === 'number' && typeof bVal === 'number') {
        return order === 'asc' ? aVal - bVal : bVal - aVal;
      }

      return 0;
    });

    return new ArrayHelper(sorted); // return a new chainable instance
  }

  map<R>(callback: (item: T, index: number) => R): R[] {
    return this.array.map(callback);
  }

  toArray(): T[] {
    return this.array;
  }
}

// Optional factory function
export const sortMapArray = <T>(array: T[]) => new ArrayHelper(array);
